// extracted by mini-css-extract-plugin
export var brand = "_c1-9";
export var compact = "_c1-6";
export var extraSmall = "_c1-7";
export var icon = "_c1-0";
export var large = "_c1-4";
export var light = "_c1-1";
export var medium = "_c1-5";
export var outline = "_c1-b";
export var primaryDark = "_c1-a";
export var primaryLight = "_c1-8";
export var primaryModern = "_c1-c";
export var success = "_c1-2";
export var successSolid = "_c1-3";